import { nanoid } from 'nanoid';
import { POLL_RATING_SMILIES as QuestionType } from '../../../../../poll';
import { assignProperties, Unboxed } from '../../../../schemaUtils';
import { config } from './RatingSmiliesPoll.config';

type AnswerType = Unboxed<QuestionType['data']['answers']>;

export function generateQuestion(
  answers: AnswerType[] = [],
  overrides: Partial<QuestionType['data']> = {},
): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: '',
        maximumValue: 3,
        autoCommit: false,
        autoNext: false,
        hasComment: false,
        image: undefined,
        imageMap: undefined,
        hasGratitude: false,
        hasTimer: false,
        requiresAnswer: true,
        goToRules: [],
        logicRules: [],
        answers,
      },
      overrides,
    ),
  };
}

export function generateAnswer(overrides: Partial<AnswerType> = {}): AnswerType {
  return {
    id: nanoid(10),
    exclusiveAnswer: true,
    text: '',
    ...overrides,
  };
}
